import React from 'react';
import {Routes, Route} from 'react-router';

import Form from './Form';
import Success from './Success';

const Registration = () => (
  <>
    <Routes>
      <Route path="success" element={<Success />} />
      <Route path=":token" element={<Form />} />
    </Routes>
  </>
);

export {Registration};
